export default __webpack_public_path__ + "static/media/thumbs-up.58491c66.svg";